import './Mission.scss';

import React from 'react';
import {Button, ButtonType, Colors} from '../components';
import Image from '../components/Image';
import {useAppStore} from '../data/AppStore';
import {buildHtmlText, logger} from '../utilities';
import {shallow} from "zustand/shallow";
import {useNavigate} from "react-router-dom";

const LOG_PREFIX = '[Mission.js]';

const Mission = (props) => {
    const navigate = useNavigate();
    const [COMPANY, OFFERINGS] = useAppStore(
        (state) => [state.COMPANY, state.OFFERINGS],
        shallow
    )

    if (!COMPANY) {
        return <div>{"Company data wasn't loaded successfully!"}</div>;
    }

    if (!OFFERINGS || !OFFERINGS.length) {
        return <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh'
        }}>
            <div>No offerings have been defined for this customer!</div>
            <br/>
            <Button
                type={ButtonType.Backward}
                colorTheme={Colors.Orange}
                label={'Return Home'}
                onClick={() => navigate('/home')}
            />
        </div>;
    }

    logger.debug(LOG_PREFIX, '.render()', {props});
    return (
        <div className='contentWrapper'>
            <div className={'missionStatement'}>
                <div className={'missionStatement-logo'}>
                    <Image src={COMPANY.settings.logo_url} fallbackSrc={null} alt={`${COMPANY.name} logo`}
                           className={'logo'}/>
                </div>
                <p dangerouslySetInnerHTML={{__html: buildHtmlText(COMPANY.settings.mission_statement)}}/>
            </div>
            <div className={'statementButtonWrapper'}>
                <Button
                    type={ButtonType.Forward}
                    colorTheme={Colors.Orange}
                    className={'continueButton'}
                    onClick={() => navigate(`/offering/${OFFERINGS[0].id}`, {replace: true})}
                    label='Continue'
                />
            </div>
        </div>
    );
}

export default Mission;